import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-top-left">
          <span>✦ PERSONAL DETAILS</span>
          <span>CONSIDERED DESIGNS</span>
          <span>ORDER SUPPORT</span>
        </div>
        <div className="header-top-right">
          <Link onClick={toTop} to="/contact">Questions? Contact us &gt;</Link>
        </div>
      </div>

      <div className="header-main">
        <Link to="/" className="logo" onClick={toTop}>
          <h1>Jskerandco</h1>
        </Link>

        <nav className="main-nav">
          <ul>
            <li>
              <Link to="/shop">SHOP </Link>
            </li>
            <li>
              <Link to="/about">ABOUT US</Link>
            </li>
            <li>
              <Link to="/faqs">HELP CENTER</Link>
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          <Link to="/cartpage" className="action-icon cart-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        </div>
      </div>

      <div className="header-promo">
        <span>Explore jewelry chosen for gifting, milestones, and everyday wear</span>
      </div>
    </header>
  );
}

export default Header;
